"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Header = exports.Container = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _TextButton = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/action/TextButton"));
var _Body = _interopRequireWildcard(require("@oberoninternal/travelbase-ds/components/primitive/Body"));
var _Special = _interopRequireDefault(require("@oberoninternal/travelbase-ds/svg/Special.svg"));
var _validInterval = _interopRequireDefault(require("@oberoninternal/travelbase-ds/utils/validInterval"));
var _grid = require("@rebass/grid");
var _addDays = _interopRequireDefault(require("date-fns/addDays"));
var _addMonths = _interopRequireDefault(require("date-fns/addMonths"));
var _endOfMonth = _interopRequireDefault(require("date-fns/endOfMonth"));
var _isSameDay = _interopRequireDefault(require("date-fns/isSameDay"));
var _isWithinInterval = _interopRequireDefault(require("date-fns/isWithinInterval"));
var _startOfMonth = _interopRequireDefault(require("date-fns/startOfMonth"));
var _lodash = _interopRequireDefault(require("lodash.isequal"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactPopper = require("react-popper");
var _Button = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/action/Button"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useQueryParams = require("use-query-params");
var _parseToDateString = _interopRequireDefault(require("../constants/parseToDateString"));
var _graphql = require("../generated/graphql");
var _usePlannerFetcher = _interopRequireDefault(require("../hooks/planner/usePlannerFetcher"));
var _useTripPlannerQuery = _interopRequireDefault(require("../hooks/tripPlanner/useTripPlannerQuery"));
var _usePrevious = _interopRequireDefault(require("../hooks/usePrevious"));
var _useQueryParams2 = _interopRequireDefault(require("../hooks/useQueryParams"));
var _planner = require("../utils/planner");
var _trip = require("../utils/trip");
var _AvailableSpecials = _interopRequireDefault(require("./AvailableSpecials"));
var _Divider = _interopRequireDefault(require("./Divider"));
var _MemoizedPlannerMonth = _interopRequireDefault(require("./MemoizedPlannerMonth"));
var _Planner = _interopRequireWildcard(require("./Planner"));
var _PlannerControls = _interopRequireDefault(require("./PlannerControls"));
var _PlannerHelp = _interopRequireDefault(require("./PlannerHelp"));
var _PlannerInfoText = _interopRequireDefault(require("./PlannerInfoText"));
var _SpecialFilterInput = _interopRequireDefault(require("./SpecialFilterInput"));
var _TripGroupInput = _interopRequireDefault(require("./TripGroupInput"));
var _UnitStickyBar = _interopRequireDefault(require("./UnitStickyBar"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const defaultInitialStart = (0, _startOfMonth.default)(new Date());
const TripPlanner = ({
  slug,
  booking,
  setBooking,
  state,
  onClick: dayClickHandler,
  onHover: dayHoverHandler,
  set,
  clear,
  maxOccupancy,
  minOccupancy,
  petsAllowed,
  headerChildren,
  initialState,
  lazyLoading,
  reserving,
  hideExplanation = false,
  iframe,
  type = 'unit',
  initialCenterMonth,
  hasInlineReservationBar,
  onSubmit
}) => {
  const {
    amountAdults,
    amountChildren,
    amountPets,
    amountBabies,
    amountYouths,
    arrivalDate,
    departureDate,
    trip: selectedTrip
  } = (0, _trip.withDefaultBookingValues)(booking);
  const viewportRef = (0, _react.useRef)(null);
  const {
    period,
    selecting
  } = state;
  const totalPersonsAmount = amountAdults + amountChildren + amountYouths;
  const [{
    specialId: specialFilter
  }] = (0, _useQueryParams2.default)({
    specialId: _useQueryParams.StringParam
  });
  const travelGroup = (0, _react.useMemo)(() => ({
    persons: totalPersonsAmount,
    pets: amountPets,
    babies: amountBabies
  }), [amountBabies, amountPets, totalPersonsAmount]);
  const initialTravelGroup = (0, _react.useRef)(travelGroup);
  const prevTravelGroup = (0, _usePrevious.default)(travelGroup);
  const [{
    data,
    variables
  }, {
    readQuery,
    writeQuery,
    query
  }] = (0, _useTripPlannerQuery.default)(_objectSpread({
    slug,
    start: (0, _parseToDateString.default)((0, _startOfMonth.default)(initialState.period?.start ?? initialCenterMonth ?? defaultInitialStart)),
    end: (0, _parseToDateString.default)((0, _endOfMonth.default)(initialState.period?.start ?? initialCenterMonth ?? defaultInitialStart))
  }, initialTravelGroup.current));
  const allTrips = (0, _react.useMemo)(() => data?.rentalUnit?.trips ?? [], [data?.rentalUnit?.trips]);
  const trips = specialFilter ? allTrips.filter(trip => trip.specialId === specialFilter) : allTrips;
  const fetcher = (0, _react.useCallback)(async months => {
    // normally we'd use fetchMore for this but somehow it doesn't look in the cache first.
    // also because we can only fetch 1 month per request we'll batch them and execute them in parallel.
    const promises = [];
    for (const month of months) {
      const vars = _objectSpread({
        start: (0, _parseToDateString.default)(month),
        end: (0, _parseToDateString.default)((0, _endOfMonth.default)(month))
      }, travelGroup);
      const execute = async () => {
        const mergedVars = _objectSpread(_objectSpread({}, variables), vars);
        const result = await query(mergedVars);

        // as all trips get added to the main query we need to filter the trips only for that month in
        // order to avoid  duplicates

        const isMain = (0, _lodash.default)(mergedVars, variables);
        if (isMain) {
          const monthInterval = {
            start: new Date(variables.start),
            end: new Date(variables.end)
          };
          return (0, _trip.filterTripsWithInterval)(result.data.rentalUnit?.trips ?? [], monthInterval);
        }
        return result.data.rentalUnit?.trips ?? [];
      };
      const promise = execute();
      promises.push(promise);
    }
    const results = await Promise.all(promises);
    const prev = readQuery();
    if (!prev?.rentalUnit) {
      return;
    }
    const monthsInterval = {
      start: (0, _startOfMonth.default)(months[0]),
      end: (0, _startOfMonth.default)((0, _addMonths.default)(months[months.length - 1], 1))
    };
    writeQuery(_objectSpread(_objectSpread({}, prev), {}, {
      rentalUnit: _objectSpread(_objectSpread({}, prev?.rentalUnit), {}, {
        trips: [
        // we remove all trips for the requested months in order to avoid duplicates
        ...(0, _trip.filterTripsWithInterval)(prev.rentalUnit?.trips ?? [], monthsInterval, true), ...results.flat()]
      })
    }));
  }, [query, readQuery, travelGroup, variables, writeQuery]);
  const [{
    loading: fetching,
    loadedMonths
  }, {
    isLoaded,
    loadMore,
    invalidate
  }] = (0, _usePlannerFetcher.default)(fetcher, lazyLoading);
  const loading = fetching || !!lazyLoading;
  const {
    0: monthsInView,
    1: setMonthsInView
  } = (0, _react.useState)(null);
  const monthsInViewLoaded = (0, _react.useMemo)(() => !!monthsInView && !loading && monthsInView.every(month => isLoaded(month)), [monthsInView, isLoaded, loading]);
  const cachedPeriod = (0, _react.useRef)(period);

  // When the travelgroup changes we need to refetch the trips for the days in view
  (0, _react.useEffect)(() => {
    if (!(0, _lodash.default)(travelGroup, prevTravelGroup)) {
      if (data?.rentalUnit?.id) {
        writeQuery(_objectSpread(_objectSpread({}, data), {}, {
          rentalUnit: _objectSpread(_objectSpread({}, data?.rentalUnit), {}, {
            trips: []
          })
        }));
        invalidate();
      }
    }
  }, [data, monthsInView, invalidate, prevTravelGroup, travelGroup, writeQuery]);

  // when invalidated we need to trigger the query manually again
  (0, _react.useEffect)(() => {
    if (!loadedMonths && monthsInView) {
      loadMore(monthsInView);
    }
  }, [monthsInView, loadMore, loadedMonths]);
  const tripsInView = (0, _react.useMemo)(() => {
    if (monthsInView && trips.length > 0) {
      const [start, end] = monthsInView;
      return trips.filter(trip => (0, _isWithinInterval.default)(new Date(trip.date), {
        start,
        end: (0, _addMonths.default)(end ?? start, 1)
      }));
    }
    return [];
  }, [monthsInView, trips]);

  // Unique specials that are in view
  const specialsInView = tripsInView.map(trip => trip.specialId).filter((specialId, i, self) => !!specialId && self.indexOf(specialId) === i);
  const selectedTrips = (0, _react.useMemo)(() => {
    if (selecting || !(0, _validInterval.default)(period)) {
      return undefined;
    }
    return allTrips.filter(trip => (0, _isSameDay.default)(new Date(trip.date), period.start) && (0, _isSameDay.default)((0, _addDays.default)(new Date(trip.date), trip.duration), period.end)).sort((a, b) => a.price - b.price);
  }, [period, selecting, allTrips]);
  const periodColor = (0, _planner.getPeriodColor)(selectedTrips ?? [], specialFilter);
  const startOfPeriod = period?.start ? +period.start : arrivalDate;
  (0, _react.useEffect)(() => {
    if (selecting || !monthsInViewLoaded) {
      return;
    }
    const periodChanged = !(0, _lodash.default)(cachedPeriod.current, period);
    if ((0, _validInterval.default)(period) && periodChanged && !selecting) {
      const formatted = (0, _trip.convertToDateStrings)(period);
      const [trip] = (0, _trip.getTripsFromPeriod)(period, trips) ?? [];
      setBooking(_objectSpread(_objectSpread({}, formatted), {}, {
        trip: trip ?? selectedTrip
      }));
      cachedPeriod.current = period;
    }
    // reset if we haven't selected a period
    else if (selectedTrip && !(0, _validInterval.default)(period)) {
      setBooking({
        arrivalDate: undefined,
        departureDate: undefined,
        trip: undefined
      });
      cachedPeriod.current = null;
    }
    // if we have selected a trip but its stale, replace it with the correct one
    else if ((0, _validInterval.default)(period) && !periodChanged && selectedTrip) {
      const [trip] = (0, _trip.getTripsFromPeriod)(period, trips) ?? [];
      if (!(0, _lodash.default)(trip, selectedTrip)) {
        setBooking({
          trip
        });
      }
    }
    // only runs when the selected period or the data changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [period, data, monthsInViewLoaded]);
  const deselect = (0, _react.useCallback)(() => {
    clear();
    setBooking({
      trip: undefined,
      arrivalDate: undefined,
      departureDate: undefined
    });
    cachedPeriod.current = null;
  }, [clear, setBooking]);
  (0, _react.useEffect)(() => {
    if (!monthsInViewLoaded) {
      return;
    }
    if (arrivalDate && departureDate && !selectedTrip && trips.length > 0) {
      const duration = (0, _trip.getTripDuration)(arrivalDate, departureDate);
      const [foundTrip] = trips.filter(trip => trip.date === arrivalDate && trip.duration === duration).sort((a, b) => a.price - b.price);
      if (foundTrip) {
        setBooking({
          trip: foundTrip
        });
      }
    }
    if (arrivalDate && departureDate && !selectedTrip) {
      const periodFromBooking = (0, _trip.convertToPeriod)(arrivalDate, departureDate);
      const tripsFromPeriod = (0, _validInterval.default)(periodFromBooking) ? (0, _trip.getTripsFromPeriod)(periodFromBooking, trips, true) : null;
      if (!tripsFromPeriod?.length) {
        deselect();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [arrivalDate, departureDate, monthsInViewLoaded, data]);
  (0, _react.useEffect)(() => {
    if (startOfPeriod && viewportRef.current) {
      viewportRef.current.plannerViewActions.jumpToMonth(new Date(startOfPeriod), true);
    }
  }, [startOfPeriod]);
  return __jsx(_Planner.PlannerContainer, null, __jsx(_Planner.default, {
    monthsRef: viewportRef,
    isSelecting: selecting,
    period: period,
    trips: trips,
    isMonthLoaded: isLoaded,
    onDayClick: dayClickHandler,
    onDayMouseEnter: dayHoverHandler,
    defaultFontColor: periodColor,
    periodColor: periodColor,
    initialCenterMonth: period?.start ?? initialCenterMonth,
    onInViewIntervalChange: months => {
      loadMore(months);
      setMonthsInView(months);
    },
    onClickOutside: () => {
      if (selecting) {
        set({
          selecting: false,
          period: null
        });
      }
    },
    PlannerMonthComponent: _MemoizedPlannerMonth.default
  }, __jsx(_Planner.PlannerHeader, {
    padding: ['2rem 2rem 0 2rem', null, 0]
  }, headerChildren, __jsx(_PlannerControls.default, {
    mt: [null, null, 8],
    loading: loading,
    mb: iframe ? [null, null, '1rem'] : [null, null, '8rem']
  }, __jsx(TripGroupWrapper, null, __jsx(_Body.default, {
    className: "gt-s",
    style: {
      whiteSpace: 'nowrap',
      marginRight: '0.8rem'
    }
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "P0UVuU",
    defaultMessage: [{
      "type": 0,
      "value": "Reisgezelschap"
    }]
  })), __jsx(StyledTripGroupInput, {
    loading: loading,
    booking: booking,
    setBooking: setBooking,
    width: [1, null, '20rem', '30rem'],
    maxOccupancy: maxOccupancy,
    minOccupancy: minOccupancy,
    petsAllowed: petsAllowed
  }), __jsx(_reactPopper.Manager, null, __jsx(_reactPopper.Reference, null, ({
    ref
  }) => __jsx(_SpecialFilterInput.default, {
    specialIds: specialsInView,
    beforeOnChange: deselect,
    ref: ref
  })), monthsInViewLoaded && __jsx(_PlannerInfoText.default, {
    allTripsCount: allTrips.length,
    tripsInViewCount: tripsInView.length,
    specialFilterActive: !!specialFilter
  }))), __jsx(_Divider.default, {
    my: 0,
    className: "lt-s"
  }), __jsx(_grid.Flex, {
    width: 1
  }, __jsx(_PlannerHelp.default, {
    brand: data?.rentalUnit?.brand,
    rentalUnitCode: data?.rentalUnit?.code,
    rentalUnitName: data?.rentalUnit?.name,
    className: "lt-s",
    bookingIsValid: !!(booking.arrivalDate && booking.departureDate),
    type: type,
    reserving: reserving,
    onBookingReservation: onSubmit
  }))))), !hideExplanation && __jsx(_grid.Flex, {
    className: "gt-s",
    justifyContent: "space-between",
    alignItems: "center",
    width: 1
  }, __jsx(_TextButton.default, {
    onClick: deselect,
    disabled: !period
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "Ek0UZb",
    defaultMessage: [{
      "type": 0,
      "value": "Selectie verwijderen"
    }]
  })), tripsInView?.some(trip => trip.type !== _graphql.TripTypeEnum.Regular && trip.originalPrice) && __jsx(SpecialText, null, __jsx(_Special.default, null), __jsx(_reactIntl.FormattedMessage, {
    id: "TCXQxw",
    defaultMessage: [{
      "type": 0,
      "value": "Op deze datum is een korting van toepassing."
    }]
  })), __jsx(_PlannerHelp.default, {
    brand: data?.rentalUnit?.brand,
    rentalUnitCode: data?.rentalUnit?.code,
    rentalUnitName: data?.rentalUnit?.name,
    bookingIsValid: !!(booking.arrivalDate && booking.departureDate),
    type: type,
    reserving: reserving,
    onBookingReservation: onSubmit
  })), hasInlineReservationBar && __jsx(_UnitStickyBar.default, {
    plannerIsOpen: true,
    booking: booking,
    hasRelativePosition: true,
    confirmButton: __jsx(_Button.default, {
      style: {
        marginLeft: 'auto'
      },
      size: "large",
      variant: "primary",
      disabled: !booking.trip,
      onClick: onSubmit
    }, __jsx(_reactIntl.FormattedMessage, {
      id: "tHmTKn",
      defaultMessage: [{
        "type": 0,
        "value": "Reserveren"
      }]
    }))
  }), __jsx(_AvailableSpecials.default, {
    trips: selectedTrips,
    booking: booking,
    setBooking: setBooking
  }));
};
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(TripPlanner);
const Header = exports.Header = _styledComponents.default.div.withConfig({
  displayName: "TripPlanner__Header",
  componentId: "sc-8vjrqs-0"
})(["@media screen and (max-width:", "px){padding:2rem 2rem 0 2rem;box-shadow:0 0 40px 0 rgba(16,36,48,0.1);}"], ({
  theme
}) => theme.mediaQueriesValues.s + 1);
const SpecialText = _styledComponents.default.div.withConfig({
  displayName: "TripPlanner__SpecialText",
  componentId: "sc-8vjrqs-1"
})(["display:flex;align-items:center;color:", ";svg{margin-right:0.5rem;}"], ({
  theme
}) => theme.colors.primary['80']);
const Container = exports.Container = (0, _styledComponents.default)(_grid.Box).withConfig({
  displayName: "TripPlanner__Container",
  componentId: "sc-8vjrqs-2"
})(["@media screen and (max-width:", "px){max-height:100vh;height:100%;display:flex;flex-direction:column;}"], ({
  theme
}) => theme.mediaQueriesValues.s + 1);
const StyledTripGroupInput = (0, _styledComponents.default)(_TripGroupInput.default).withConfig({
  displayName: "TripPlanner__StyledTripGroupInput",
  componentId: "sc-8vjrqs-3"
})(["--borderRadius:3rem;"]);
const TripGroupWrapper = (0, _styledComponents.default)(_grid.Flex).withConfig({
  displayName: "TripPlanner__TripGroupWrapper",
  componentId: "sc-8vjrqs-4"
})(["position:relative;@media screen and (min-width:", "){flex-direction:row;align-items:center;> * + *{margin:0 0 0 ", ";}}@media screen and (max-width:", "px){column-gap:0.8rem;width:100%;padding-bottom:", ";justify-content:space-between;> *{flex:1;}> ", ":last-of-type{margin-left:0.8rem;}}"], ({
  theme
}) => theme.mediaQueries.s, ({
  theme
}) => theme.spacing['30_Small'], ({
  theme
}) => theme.mediaQueriesValues.s - 1, ({
  theme
}) => theme.spacing['40_Standard'], _Body.BodyInner);